module.exports = __webpack_public_path__ + "static/media/print.1937d59a.svg";